export function CookiePage() {
  return (
    <>
      <style>{`
        .nk-entry .table {
          --bs-table-color: inherit;
          --bs-table-bg: transparent;
          --bs-table-border-color: rgba(255, 255, 255, 0.15);
          color: inherit;
        }
        .nk-entry .table > thead th,
        .nk-entry .table > tbody td { color: inherit; }
      `}</style>
      <header className="nk-header" id="home">
        <div className="section section-lg section-b-0">
          <div className="section-heading">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-6 col-lg-8">
                  <div className="position-relative text-center">
                    <h2 className="title text-gradient-heading fw-semibold display-6 mb-4">
                      Cookie Policy
                    </h2>
                    <p className="fs-8">
                      How and when Yapamar uses cookies and similar
                      technologies, and the choices you have.
                    </p>
                    <p className="fs-10 text-muted fw-semibold">
                      Last updated: October 14, 2026
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <main className="nk-main">
        <div className="section section-xl section-t-0">
          <div className="section-content">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-8">
                  <div className="nk-entry">
                    <h5>Annex 1 - Cookies</h5>

                    <h6>1. What Are Cookies?</h6>
                    <p>
                      Cookies are small files that can be used to improve your
                      user experience on our website. The cookies are stored on
                      your computer or mobile device when you visit our site.
                    </p>
                    <p>
                      There are two main types of cookies, session cookies and
                      permanent cookies. Session cookies are temporary cookies
                      and are deleted after your visit to our website when you
                      close the browser. Permanent cookies are stored for a
                      longer time period depending on their purpose.
                    </p>
                    <p>
                      Depending on your preferences, we use cookies and similar
                      technologies on our website to improve user experience by
                      personalizing the content you see, to improve our service
                      by analysing traffic on our website and the functioning of
                      our features, and for marketing purposes.
                    </p>
                    <p>
                      Some cookies are so-called third-party cookies placed on
                      our site by third parties.
                    </p>

                    <h6>2. What Kind of Cookies Do We Use?</h6>
                    <p>
                      <strong>Necessary cookies:</strong> Necessary cookies
                      implement functions that are essential for the functioning
                      and proper use of the website. For example, these cookies
                      enable proper navigation on the website by saving your
                      login information while you browse from one page to
                      another on our website.
                    </p>
                    <p>
                      <strong>Preference cookies:</strong> Preference cookies
                      enable us to personalise the website according to your
                      preferences. For example, they are used to save
                      information about past choices you made on the website,
                      such as your language settings.
                    </p>
                    <p>
                      <strong>Statistics cookies:</strong> Statistics cookies
                      help us to understand how our visitors use the website.
                      These cookies help us compile statistics on how visitors
                      move around the website and which pages on our website are
                      popular. We use this information to improve our website.
                    </p>
                    <p>
                      <strong>Marketing cookies:</strong> Marketing cookies make
                      it possible for us to display ads on our website that are
                      relevant to you. These cookies track your behaviour across
                      different websites.
                    </p>

                    <h6>3. When Do We Use Cookies?</h6>
                    <p>
                      Necessary cookies are required for the proper functioning
                      of the website and cannot be turned off. We use all other
                      cookies only based on your consent. When you first visit
                      our website you can accept or decline the use of
                      statistics cookies in the cookie banner, and you can
                      change your choice at any time via the &quot;Cookie
                      Settings&quot; link in the website footer. You may also
                      control or delete cookies through your browser settings at
                      any time, but this may affect the functioning of the
                      website.
                    </p>

                    <h6>4. Overview of Cookies on Our Website</h6>

                    <p className="fw-semibold mb-2">Necessary Cookies</p>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Provider</th>
                            <th>Purpose</th>
                            <th>Storage Duration</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>yapamar_cookie_consent</td>
                            <td>Yapamar</td>
                            <td>
                              Stores the user&apos;s cookie consent state for
                              the current domain.
                            </td>
                            <td>Persistent</td>
                            <td>HTML Local Storage</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <p className="fw-semibold mb-2">Preference</p>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Provider</th>
                            <th>Purpose</th>
                            <th>Storage Duration</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>chakra-ui-color-mode</td>
                            <td>Yapamar</td>
                            <td>
                              Necessary for the functionality of the website
                              chatbox function.
                            </td>
                            <td>Persistent</td>
                            <td>HTML Local Storage</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <p className="fw-semibold mb-2">Statistics</p>
                    <div className="table-responsive mb-5">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Provider</th>
                            <th>Purpose</th>
                            <th>Storage Duration</th>
                            <th>Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Amplitude</td>
                            <td>Amplitude</td>
                            <td>
                              Registers statistical data on users&apos;
                              behaviour on the website and captures
                              acquisition-source information (referring URL,
                              referring domain, UTM parameters, click
                              identifiers such as gclid and fbclid). Used for
                              internal analytics by the website operator.
                            </td>
                            <td>365 days</td>
                            <td>HTTP Cookie</td>
                          </tr>
                          <tr>
                            <td>Sentry</td>
                            <td>Sentry</td>
                            <td>
                              Registers data on visitors&apos; website
                              behaviour. This is used for internal analysis and
                              website optimization.
                            </td>
                            <td>Persistent</td>
                            <td>HTML Local Storage</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
